import { render, staticRenderFns } from "./SimilarRecipes.vue?vue&type=template&id=19ab9d23"
import script from "./SimilarRecipes.vue?vue&type=script&lang=js"
export * from "./SimilarRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports